import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentUserId } from "@/utils";

export class ProfileReq extends BaseReq {
  name: string = ""; // 项目名称
  provinceId: number | undefined = undefined; // 所在地区 - 省
  cityId: number | undefined = undefined; // 所在地区 - 市
  districtId: number | undefined = undefined; // 所在地区 - 区
  address: string = ""; // 详细地址
  introduction: string = ""; // 项目简介
  remark: string | undefined = undefined; // 备注
  contactType: string = "";
  guaranteeProjectLeaderId: number | undefined = undefined;
  guaranteeProjectOwnerHeadName: string = "";
  guaranteeProjectOwnerId: number | undefined = undefined;
  projectId: number | undefined = undefined;
}

export class ProfilePageReq extends PaginationReq {
  keyWord: string | undefined = undefined; // 项目名称
  provinceId: number | undefined = undefined; // 所在地区 - 省
  cityId: number | undefined = undefined; // 所在地区 - 市
  districtId: number | undefined = undefined; // 所在地区 - 区
  guaranteeProjectLeaderId: string | undefined = undefined; // 业务员姓名
  flowStatus: string | undefined = undefined; // 审批状态
}

export class ProfileListRecord extends UpdaterResp {
  address: string;
  cityId: number;
  cityName: string;
  contactType: string;
  createBy: string;
  createName: string;
  createTime: string;
  deleteBy: string;
  deleteName: string;
  deleteTime: string;
  districtId: number;
  districtName: string;
  flowStatus: string;
  flowStatusName: string;
  guaranteeProjectLeaderId: number;
  guaranteeProjectLeaderName: string;
  guaranteeProjectOwnerHeadName: string;
  guaranteeProjectOwnerId: number;
  guaranteeProjectOwnerName: string;
  id: number;
  introduction: string;
  isRecycled: number;
  lastModifiedTime: string;
  maintenanceGuaranteeAgreementCount: number;
  maintenanceGuaranteeCount: number;
  mark: number;
  modifiedBy: string;
  modifiedName: string;
  operationAgreementCount: number;
  operationCount: number;
  projectBizNo: string;
  projectId: number;
  projectName: string;
  provinceId: number;
  provinceName: string;
  recycleDesc: string;
}

export class ProfilePageResp extends PaginationResp<ProfileListRecord> {}

export class ProfileSimpleListReq extends BaseReq {
  otherStatus: string[] = [];
  projectStatus: string | undefined = undefined;
  flowStatus: string | undefined = undefined;
  bizType: string | undefined = undefined;
  addRightBizType: string | undefined = undefined;
  projectName: any = undefined;
}

export class ProfileSimpleRecord {
  id: number = 0;
  name: string = "";
}

export class ProfileSimpleListResp {
  records: ProfileSimpleRecord[] = [];
}

export class Cooperation {
  id: string = "";
  cooperationCompanyId: string = "";
  companyName: string = "";
  customer: {
    contacts: string;
    cooperationCompanyId: string;
    mobile: string;
  };
}

export class ProfileDetailResp extends UpdaterResp {
  address: string;
  cityId: number;
  cityName: string;
  contactType: string;
  createBy: string;
  createName: string;
  createTime: string;
  deleteBy: string;
  deleteName: string;
  deleteTime: string;
  districtId: number;
  districtName: string;
  flowStatus: string;
  flowStatusName: string;
  guaranteeProjectLeaderId: number;
  guaranteeProjectLeaderName: string;
  guaranteeProjectOwnerHeadName: string;
  guaranteeProjectOwnerId: number;
  guaranteeProjectOwnerName: string;
  id: number;
  introduction: string;
  isRecycled: number;
  lastModifiedTime: string;
  maintenanceGuaranteeAgreementCount: number;
  maintenanceGuaranteeCount: number;
  mark: number;
  modifiedBy: string;
  modifiedName: string;
  operationAgreementCount: number;
  operationCount: number;
  projectBizNo: string;
  projectId: number;
  projectName: string;
  provinceId: number;
  provinceName: string;
  recycleDesc: string;
}

export interface ProjectItem {
  bizNo?: string;
  id: string;
  name: string;
  status?: string;
}
